<template>
    <div>
        <div class="row chatnav" v-if="workspaceData.activity_type != 'zoho-dashboard'">
            <div class="col chatnav-opts">
                <ul class="list-inline chats">
                    <li><a href="javascript://" :class="ChatactiveClass" @click="navigateActivity('chat')"> Chat</a></li>
                    <li><a href="javascript://" :class="FilesactiveClass" @click="navigateActivity('files')">Files </a></li>
                    <li><a href="javascript://" :class="SummaryactiveClass" @click="navigateActivity('summary')">Summary </a></li>
                    <li v-if="workspaceData.type == 'accounting_service'"><a href="javascript://" :class="CompanyInfoactiveClass" @click="navigateActivity('zoho-dashboard')">Zoho</a></li>
                    <li v-if="Req_docs.length"><a href="javascript://" :class="RequiredDocumentsactiveClass" @click="navigateActivity('required_documents')">Required documents</a></li>
                </ul>   
                <ul class="chat-menu-right" v-if="QlinkPresent">
                    <li >
                        <span>Quick links:</span>
                    </li>
                    <li v-for="links in MasterData.data.quick_links " :key="links.id">
                        <a :href="links.link" target="_blank" class="btn-link"> {{formatText(links.type)}}  </a>
                    </li>
                </ul>
                <a href="javascript://"  @click="$router.go(-1)" class="btn-close">  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#292c34"></path></svg></a>
            </div>
        </div>
         
        <chatWindow v-if="workspaceData.activity_type=='chat'" :subscription="MasterData.data"/>
        <files v-if="workspaceData.activity_type=='files'"  :subscription="MasterData.data"/>
        <Actsummary v-if="workspaceData.activity_type=='summary'"  :subscription="MasterData.data"/>
        <BusinessInfo v-if="workspaceData.activity_type=='company_info'"  :subscription="MasterData.data"/>
        <ZohoDashboard v-if="workspaceData.activity_type=='zoho-dashboard'" :subscription="workspaceData"/>
        <RequiredDocuments v-if="workspaceData.activity_type=='required_documents'"  :subscription="Req_docs"/>
    </div>
</template>
<script>
import activityService from "../../services/activity"
import chatWindow from "../../components/chat.vue"
import files from "../../components/files.vue"
import Actsummary  from "../../components/summary.vue"
import BusinessInfo  from "../../components/business_info.vue"
import RequiredDocuments  from "../../components/required_documents.vue"
import ZohoDashboard  from "../../components/zoho-dashboard.vue"
export default {
    name:'main-activity',
    data(){
        return{ 
            ChatactiveClass:'',
            FilesactiveClass:'',
            SummaryactiveClass:'',
            CompanyInfoactiveClass:'',
            RequiredDocumentsactiveClass:'',
            QlinkPresent:false,
            MasterData:{},
            Req_docs:{}
        }
    },
    components:{
        chatWindow,
        files,
        Actsummary,
        BusinessInfo,
        RequiredDocuments,
        ZohoDashboard
    },
    props: ['workspaceData'],
    watch:{
        workspaceData:function(data){
            if(data.type!= undefined){
                this.ChatactiveClass='';
                this.FilesactiveClass='';
                this.SummaryactiveClass='';
                if(data.activity_type=='chat'){
                    this.ChatactiveClass='active';
                }
                if(data.activity_type=='files'){
                    this.FilesactiveClass='active';
                }
                if(data.activity_type=='summary'){
                    this.SummaryactiveClass='active';
                }
                if(data.activity_type=='company_info'){
                    this.CompanyInfoactiveClass='active';
                }
                 if(data.activity_type=='required_documents'){
                    this.RequiredDocumentsactiveClass='active';
                }
                this.GetworkspaceData(data)
            }
        }
    },
    methods: {
        GetworkspaceData(data){
            activityService.postActivity(data)
            .then(response=>{
              this.MasterData=  response.data
              this.Req_docs=  response.data.reg_doc
              if(response.data.data.quick_links.length>0){
                  this.QlinkPresent=true
              }else{
                  this.QlinkPresent= false
              }
            //   this.$emit('service_type',{service:this.MasterData})
            })
            
        },
        formatText(str){
          var f=  str.replace("_", " ");
            return f.charAt(0).toUpperCase() + f.slice(1);
        },
        back(){
            var to = this.workspaceData.type;
            window.location.href='/'+to
        },
        navigateActivity(act_type){
            if(act_type == "zoho-dashboard"){
                window.location.href="/workspace/"+this.workspaceData.type+'/'+act_type+'/'+this.workspaceData.id
            }
            // this.$router.push({name:'workspace',params:{type:this.workspaceData.type,activity_type:act_type,id:this.workspaceData.id }})
            if(this.MasterData.data.status=='Yes'){
                window.location.href="/workspace/"+this.workspaceData.type+'/'+act_type+'/'+this.workspaceData.id
            }else{
                 this.$notify({ group: 'auth', text: 'This subscription is not active, Kindly contact your account manager.', type: 'warn' })
            }
        }
    }
};
</script>
